import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
import client from '@/store/client'
import parseData from '../util/parsedata'
import _ from 'lodash'

const getStatus = (openDate, closeDate) => {
  if ( openDate == '' && closeDate == '') return '1'
  const today = new Date()
  const open = new Date(openDate)
  const close = new Date(closeDate)
  if ( today.getTime() - close.getTime() >= 0 ) return "950"
  if ( today.getTime() - open.getTime() < 0 ) return "22"
  else return "1"
}

const langSelected = (langArry, value) => {
  let bitmap = value
  let selectedArray = []
  for ( let i = langArry.length - 1; i >= 0; i-- ){
    if ( (bitmap - langArry[i].ID) >= 0 ) {
      selectedArray.unshift(langArry[i].ID)
      bitmap -= langArry[i].ID
    }
  }
  return selectedArray
}

const updateLang = (selectedLangs) => {
  return selectedLangs.reduce( (a, b) => +a + +b, 0)
}

const phoneNum = (numberArray) => {
  if ( numberArray.length == 1 ) return ''
  return `${numberArray[1]}-${numberArray[2]}`
}

const phoneSlpit = (phoneString, faxString, rxString) => {
  const phoneArray = phoneString.split('-', 3)
  const faxArray = faxString.split('-', 3)
  const rxArray = rxString.split('-', 3)
  return {
    PhoneAreaCode: phoneArray[0] || '',
    PhoneNumber: phoneNum(phoneArray),
    PhoneExt: '',
    FaxAreaCode: faxArray[0] || '',
    FaxNumber: phoneNum(faxArray),
    FaxExt: '',
    PharmacyAreaCode: rxArray[0] || '',
    PharmacyNumber: phoneNum(rxArray),
    PharmacyExt: '',
  }
}

const getDefaultState = () => {
  return {
    orgPRetailerInfo: {
      name: ''
    },
    pretailerInfo: {
      Name: '',
      Rating: '',
      AcceptsInStoreReturnsFlag: '',
      ThirdPartyVerificationInfo: '',
      URL: '',
      TypeID: '',
      HomePageLogoHeight: '0',
      HomePageLogoWidth: '0',
      HomePageLogoLocation: '',
      LogoHeight: '0',
      LogoWidth: '0',
      LogoLocation: '',
      LogoThumbHeight: '0',
      LogoThumbWidth: '0',
      LogoThumbLocation: '',
      LogoAltTag: '',
      LogoThumbAltTag: '',
      ID: '',
      Revision: ''
    },
  }
}
const storeAttributeState = () => {
  return {
    storeInfo: {
      PRetailerID: '',
      RowStatus: '1',
      ID: '0',
      Reference: '',
      Name: '',
      Address1: '',
      Address2: '',
      Address3: '',
      CountryID: '1',
      City: '',
      State: '',
      ZipCode5: '',
      DisplayLang: [],
      Language: '',
      DataSourceTypeID: '',
      DataSourceKey: '',
      DataSourceStoreName: '',
      MallName: '',
      ManagerName: '',
      URL: '',
      DisplayPhoneNumber: '',
      DisplayFaxNumber: '',
      DisplayRxNumber: '',
      PhoneAreaCode: '',
      PhoneNumber: '',
      FaxAreaCode: '',
      FaxNumber: '',
      PharmacyAreaCode: '',
      PharmacyNumber: '',
      Latitude: '',
      Longitude: '',
      GeoCodeStatus: '',
      Hours: '',
      OpenDate: '',
      CloseDate: '',
      LastUpdatedBy: '',
      LastUpdateDate: '',
      Revision: ''
    }
  }
}
export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    ...storeAttributeState(),
    pretailerTypes: [],
    storeSearchCriteria: 'dataSourceKeySearch',
    totalOnServer: -1,
    citySearch: '',
    dataSourceKeySearch: '',
    storeIDSearch: '',
    storeNameSearch: '',
    postalCodeSearch: '',
    storeSearchState: '',
    storeSearchCounty: '1',
    storeSearchStatus: 'All Statuses',
    storeSearchResults: [],
    dataSourceTypes: [],
    pretailerByRetailer: [],
    siteSearch: '1',
    siteSearchResults: []
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_FIELD_OBJ: ({ commit }, data) => {
      commit('setFieldObj', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    RESET_STORE: ({ commit }) => {
      commit('resetStore')
    },
    GET_PRETAILER_TYPES: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPRetailerTypes', qs.stringify(this.getters['traceToken']))
        commit('setField', { key: 'pretailerTypes', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_PRETAILER_BY_RETAILER_ID: async function({commit, state}){
      try {
        const APIRes = await client.post('/v1/PRetailer.asmx/GetPRetailersByRetailerID', qs.stringify({...this.getters['traceToken'], retailerID: state.pretailerInfo.RetailerID}))
        commit('setField', { key: 'pretailerByRetailer', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_DATA_SOURCE_TYPES: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetDataSourceTypes', qs.stringify(this.getters['traceToken']))
        commit('setField', { key: 'dataSourceTypes', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    SET_PRETAILER: async function({ commit}, data ) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })
        const apiData = {
          ...this.getters['traceToken'],
          pretailerID: data,
        }
        if ( apiData.pretailerID && apiData.pretailerID != 0 ) {
          const APIRes = await client.post('/v1/PRetailer.asmx/GetPRetailer', qs.stringify(apiData) )
          const parsedRes = await parseStringPromise(APIRes.data)
          commit('setPRetailer', parsedRes.content.data[0].$)
        }
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Data Received',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    INSERT_PRETAILER: async function({commit}) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating PRetailer',
          subdetail: 'Please wait...',
        })
        const APIRes = await client.post('/v1/PRetailer.asmx/InsertPRetailer', qs.stringify(this.getters['pretailer/pretailerData']) )
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setFieldObj', { obj: 'pretailerInfo', key: 'ID', value: parsedRes.content.data[0].$.ID })
        this.dispatch('pretailer/SET_PRETAILER', parsedRes.content.data[0].$.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `New PRetailer Created`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_PRETAILER: async function({state}) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating PRetailer',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/PRetailer.asmx/UpdatePRetailer', qs.stringify(this.getters['pretailer/pretailerData']) )
        this.dispatch('pretailer/SET_PRETAILER', state.pretailerInfo.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `PRetailer Updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    SEARCH_STORE: async function({commit}, data){
      try{
        const APIData = {
          ...this.getters['pretailer/searchStoreData'],
          ...data,
        }
        const APIRes = await client.post('/v1/Store.asmx/FindStores', qs.stringify(APIData))
        const paresdRes = await parseStringPromise(APIRes.data)
        commit('setField', { key: 'totalOnServer', value: +paresdRes.content.data[0].$.Count })
        commit('setField', { key: 'storeSearchResults', value: await parseData(APIRes.data) })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_STORE: async function({commit, state, rootState}, data){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Store',
          subdetail: 'Please wait...',
        })
        const APIRes = await client.post('/v1/Store.asmx/GetStore', qs.stringify({...this.getters['traceToken'], ID: data}))
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setCurrentStore', parsedRes.content.collection[0].data[0].$ )
        commit( 'setFieldObj', {obj: 'storeInfo', key: 'DisplayLang', value: langSelected(rootState.retailerTag.allLanguages, state.storeInfo.Language)} )
        if (state.storeInfo.PhoneAreaCode != '') commit('setFieldObj', { obj: 'storeInfo', key: 'DisplayPhoneNumber', value: `${state.storeInfo.PhoneAreaCode}-${state.storeInfo.PhoneNumber}`})
        if (state.storeInfo.FaxAreaCode != '') commit('setFieldObj', { obj: 'storeInfo', key: 'DisplayFaxNumber', value: `${state.storeInfo.FaxAreaCode}-${state.storeInfo.FaxNumber}`})
        if (state.storeInfo.PharmacyAreaCode != '') commit('setFieldObj', { obj: 'storeInfo', key: 'DisplayRxNumber', value: `${state.storeInfo.PharmacyAreaCode}-${state.storeInfo.PharmacyNumber}`})
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    CHECK_FOR_DUPLICATE: async function({getters}, data){
      try{
        const APIRes = await client.post('/v1/Store.asmx/CheckForDuplicateStoreReferenceOrDataSourceKey', qs.stringify(getters['checkDuplicateData']))
        const parsedRes = await parseStringPromise(APIRes.data)
        if (parsedRes.content.data[0].$.Message == '' ) this.dispatch(`pretailer/${data}`)
        else {
          await this.dispatch('ui/SHOW_CONFIRM_DIALOG', {
          header: 'Are you sure?',
          message: parsedRes.content.data[0].$.Message,
          action: `pretailer/${data}`,
          data: null,
          nextTickAction: '',
          nextTickData: {},
          })
        }
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    INSERT_STORE: async function(){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Store',
          subdetail: 'Please wait...',
        })
        const APIRes = await client.post('/v1/Store.asmx/InsertStore', qs.stringify(this.getters['pretailer/storeData']))
        const parsedRes = await parseStringPromise(APIRes.data)
        this.dispatch('pretailer/GET_STORE', parsedRes.content.data[0].$.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Store has been successfully created`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_STORE: async function(){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Store',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Store.asmx/UpdateStore', qs.stringify(this.getters['pretailer/storeData']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Store has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    SEARCH_SITE: async function({commit}){
      try{
        const APIRes = await client.post('/v2/Site.asmx/FindByRetailerIDAndSiteType', qs.stringify(this.getters['pretailer/siteSearch']))
        commit('setField', { key: 'siteSearchResults', value: await parseData(APIRes.data) })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_SITE: async function({dispatch}, data){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Site',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/PRetailer.asmx/AttachOrDetachSites', qs.stringify({...this.getters['pretailer/siteSearch'], ...data }))
        dispatch('SEARCH_SITE')
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Site has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
  },
  getters: {
    pretailerChanged: state => !_.isEqual(state.orgPRetailerInfo, state.pretailerInfo),
    pretailerTypes: state => {
      return state.pretailerTypes.map( item => {
        return { text: item.Name, value: item.ID }
      })
    },
    dataSourceTypes: state => {
      return state.dataSourceTypes.map( item => {
        return { text: item.Name, value: item.ID }
      })
    },
    pretailerByRetailer: state => {
      return state.pretailerByRetailer.map( item => {
        return { text: `${item.Name} (${item.ID})`, value: item.ID }
      })
    },
    pretailerData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        retailerID: state.pretailerInfo.RetailerID || rootState.retailer.orgRetailerInfo.ID,
        merchantID: state.pretailerInfo.MerchantID || rootState.retailer.orgRetailerInfo.MerchantID,
        name: state.pretailerInfo.Name,
        rating: state.pretailerInfo.Rating || 0,
        acceptsInStoreReturnsFlag: state.pretailerInfo.AcceptsInStoreReturnsFlag,
        thirdPartyVerificationInfo: state.pretailerInfo.ThirdPartyVerificationInfo,
        url: state.pretailerInfo.URL,
        typeID: state.pretailerInfo.TypeID,
        homePageLogoHeight: state.pretailerInfo.HomePageLogoHeight || 0,
        homePageLogoWidth: state.pretailerInfo.HomePageLogoWidth || 0,
        homePageLogoLocation: state.pretailerInfo.HomePageLogoLocation,
        logoHeight: state.pretailerInfo.LogoHeight || 0,
        logoWidth: state.pretailerInfo.LogoWidth || 0,
        logoLocation: state.pretailerInfo.LogoLocation,
        logoThumbHeight: state.pretailerInfo.LogoThumbHeight || 0,
        logoThumbWidth: state.pretailerInfo.LogoThumbWidth || 0,
        logoThumbLocation: state.pretailerInfo.LogoThumbLocation,
        logoAltTag: state.pretailerInfo.LogoAltTag,
        logoThumbAltTag: state.pretailerInfo.LogoThumbAltTag,
        ID: state.pretailerInfo.ID, 
        revision: state.pretailerInfo.Revision
      }
    },
    searchStoreData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        merchantID: state.pretailerInfo.MerchantID,
        pRetailerID: state.pretailerInfo.ID,
        retailerID: state.pretailerInfo.RetailerID,
        status: state.storeSearchStatus,
        storeName: state.storeNameSearch,
        postalCode: state.postalCodeSearch,
        storeID: state.storeIDSearch || 0,
        state: state.storeSearchState || '',
        countryID: state.storeSearchCounty,
        city: state.citySearch,
        dataSourceKey: state.dataSourceKeySearch
      }
    },
    checkDuplicateData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        storeID: state.storeInfo.ID,
        retailerID: state.pretailerInfo.RetailerID,
        dataSourceKey: state.storeInfo.DataSourceKey,
        storeReference: state.storeInfo.Reference
      }
    },
    storeData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        ...state.storeInfo,
        ...phoneSlpit(state.storeInfo.DisplayPhoneNumber, state.storeInfo.DisplayFaxNumber, state.storeInfo.DisplayRxNumber),
        RowStatus: getStatus(state.storeInfo.OpenDate, state.storeInfo.CloseDate),
        RetailerID: state.pretailerInfo.RetailerID,
        MerchantID: state.pretailerInfo.MerchantID,
        Language: updateLang(state.storeInfo.DisplayLang),
        Latitude: state.storeInfo.Latitude || '0',
        Longitude: state.storeInfo.Longitude || '0',        
        ZipCode4: '',
        OwnerName: '',
        PostalCode: '',
        refreshStore: true
      }
    },
    siteSearch: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        retailerID: state.pretailerInfo.RetailerID,
        pretailerID: state.pretailerInfo.ID,
        siteTypeID: state.siteSearch,
      }
    },
    siteSearchResults: state => {
      return state.siteSearchResults.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    setFieldObj: function(state, data) {
      state[data.obj][data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    resetStore: function(state) {
      Object.assign(state, storeAttributeState())
    },
    setPRetailer: function(state, data) {
      state.pretailerInfo = data
      state.orgPRetailerInfo = _.cloneDeep(data)
    },
    setCurrentStore: function(state, data) {
      Object.keys(state.storeInfo).forEach(k => state.storeInfo[k] = data[k] || state.storeInfo[k])
    }
  },
}
